import environment from "environment";
import { createCorrelationId } from "./correlationId";
import { CorrelationStorage } from "./sessionStore";
import { safeStorage } from "./safeStorage";

// Adaptador entre el almacenamiento del navegador y lo que el modulo espera.
// Es lo unico especifico de esta app. Al migrar el modulo a un paquete, esto
// queda del lado de la app y el paquete solo expone createCorrelationId.
const browserStorage: CorrelationStorage = {
  get: (key) => localStorage.getItem(key),
  set: (key, value) => localStorage.setItem(key, value),
  remove: (key) => localStorage.removeItem(key),
};

// Los destinos a los que se les inyecta el header. Hoy solo originacion, que ya
// lo declara en su CORS. Otros servicios quedan afuera a proposito para no
// romper su verificacion previa con un header que no tienen permitido.
export const correlationId = createCorrelationId({
  storage: safeStorage(browserStorage),
  targets: [environment.originacionUrl],
});

// Envuelve una funcion fetch para que sume el header de correlacion a las
// llamadas que van a un destino configurado. Al resto no les toca nada.
type FetchFn = (url: string, options?: any) => Promise<Response>;

export const withCorrelation = (fetchFn: FetchFn): FetchFn => (
  url,
  options = {}
) =>
  fetchFn(url, {
    ...options,
    headers: { ...(options.headers || {}), ...correlationId.headersFor(url) },
  });

